<template>
    <v-container>
        <v-stepper v-model="step" :class="mode == 'edit' ? '' : 'fill-height'">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1" @click="mode == 'edit' ? step = 1 : {}">Informations du
                    patient
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2" @click="mode == 'edit' ? step = 2 : {}">Informations de
                    contact
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" step="3" @click="mode == 'edit' ? step = 3 : {}">Médecins
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 4" step="4" @click="mode == 'edit' ? step = 4 : {}">Cabinet
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 5" step="5" @click="mode == 'edit' ? step = 5 : {}">Travail
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-form ref="patientForm" v-model="patientInfoValid" lazy-validation>

                        <v-layout>
                            <v-flex md10 offset-md1>
                                <h3 class="headline mb-4">Informations du patient</h3>

                                <v-select
                                    v-model="gender"
                                    :items="[{text: 'Homme', value: 'male'}, {text: 'Femme', value: 'female'}, {text: 'Indéfini', value: 'undefined'}]"
                                    label="Sexe"
                                    :rules="genderRules"
                                    required
                                ></v-select>
                                <v-text-field v-model="firstname" :rules="nameRules" label="Prénom"
                                              required></v-text-field>
                                <v-text-field v-model="lastname" :rules="nameRules" label="Nom" required></v-text-field>

                                <v-menu
                                    ref="showDatePicker"
                                    v-model="showDatePicker"
                                    :close-on-content-click="false"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="birthDateFormatted"
                                            label="Date de naissance"
                                            append-icon="event"
                                            v-on="on"
                                            :rules="dateRules"
                                            @blur="birth_date = parseDate(birthDateFormatted)"
                                            required
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker ref="birthdayPicker"
                                                   locale="fr"
                                                   v-model="birth_date"
                                                   :max="new Date().toISOString()"
                                                   no-title @input="showDatePicker = false"></v-date-picker>
                                </v-menu>

                                <v-text-field
                                    v-model="opaleNumber"
                                    label="Numéro OPALE"
                                    :rules="mode === 'create' ? opaleNumberRules : []"
                                    >
                                </v-text-field>

<!--                                <v-checkbox-->
<!--                                    v-model="declinedStudy"-->
<!--                                    hide-details-->
<!--                                    label="Refus étude">-->
<!--                                </v-checkbox>-->

                                <v-checkbox
                                    v-model="declineDataCollection"
                                    hide-details
                                    label="Refuse de participer aux études">
                                </v-checkbox>

                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3 text-xs-right>
                                <v-btn :disabled="!patientInfoValid" color="success" @click="validate">Suivant
                                </v-btn>
                                    <!-- Quick patient creation disable -->
<!--                                <v-btn v-if="mode != 'edit'" :disabled="!patientInfoValid" color="secondary"
                                       @click="showQuickCreateModal" class="right">
                                    Création rapide
                                </v-btn>-->
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-form ref="contactForm" v-model="contactInfoValid" lazy-validation>
                        <v-layout>
                            <v-flex md10 offset-md1>
                                <h3 class="headline mb-4">Informations de contact pour {{ firstname }} {{
                                        lastname
                                    }}</h3>

                                <v-text-field v-if="!noEmail" :rules="emailRules"
                                              :value="email ? email.toLowerCase() : ''"
                                              @input="(value) => { setEmail(value ? value.toLowerCase() : null) }"
                                              label="Email"></v-text-field>

                                <v-checkbox
                                    v-model="noEmail"
                                    color="primary"
                                    label="Pas d'adresse email"
                                    class="mb-2 mt-0"
                                >
                                </v-checkbox>

                                <v-text-field v-model="phone" label="Téléphone"></v-text-field>
                                <v-text-field v-model="address" label="Adresse"></v-text-field>
                                <v-text-field v-model="postcode" label="Code postal"></v-text-field>
                                <v-text-field v-model="city" label="Ville"></v-text-field>
                                <v-select
                                    :items="countryList"
                                    v-model="country" label="Pays"
                                    item-text="name"
                                    item-value="name"
                                ></v-select>

                                <v-checkbox
                                    v-model="notification"
                                    hide-details
                                    color="primary"
                                    label="Notification pour le suivi">
                                </v-checkbox>

                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn :disabled="!contactInfoValid" color="success" @click="validateContact"
                                       class="right">
                                    Suivant
                                </v-btn>

                                <v-btn v-if="mode == 'create' && locked == 'null'" color="secondary" @click="skip"
                                       class="right">
                                    Passer
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">

                    <v-form ref="doctorsForm" v-model="doctorsInfoValid" lazy-validation>

                        <v-layout>
                            <v-flex md10 offset-md1>
                                <div>
                                    <h3 class="headline mb-4">Médecins</h3>

                                    <v-autocomplete
                                        v-if="!noDoctor"
                                        v-model="mainDoctorId"
                                        :items="doctorsList"
                                        label="Médecin traitant"
                                        item-text="name"
                                        item-value="id"
                                    ></v-autocomplete>
                                    <v-checkbox
                                        v-model="noDoctor"
                                        color="primary"
                                        label="Pas de médecin traitant"
                                        class="mb-3 mt-1"
                                    >
                                    </v-checkbox>

                                    <v-autocomplete
                                        v-if="!noPhysio"
                                        v-model="physioId"
                                        :items="physiosList"
                                        label="Physiothérapeute"
                                        item-text="name"
                                        item-value="id"
                                    ></v-autocomplete>

                                    <v-checkbox
                                        v-model="noPhysio"
                                        hide-details
                                        color="primary"
                                        label="Pas physiothérapeute"
                                        class="mb-4 mt-1"
                                    >
                                    </v-checkbox>

                                    <v-layout v-for="(doctor, index) in otherDoctors" :key="index" row wrap>
                                        <v-flex md3 pr-2>
                                            <v-select
                                                :ref="'typeSelect_' + index"
                                                :value="doctor.pivot.type"
                                                @change="(value) => { setOtherDoctorType({index: index, data: value}) }"
                                                :items="[
                                                    {text: 'Cardiologue', value: 'CARDIO'},
                                                    {text: 'Médecin du sport', value: 'SPORT'},
                                                    {text: 'Rhumatologue', value: 'RHUMAT'},
                                                    {text: 'Autre médecin', value: 'OTHER'}
                                                ]"
                                                label="Type"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex md4 v-if="doctor.pivot.type === 'OTHER'" pr-2>
                                            <v-text-field
                                                required
                                                :value="doctor.pivot.label"
                                                @change="(value) => { return setOtherDoctorLabel({index: index, data: value}) }"
                                                label="Domaine"></v-text-field>
                                        </v-flex>
                                        <v-flex md4>
                                            <v-autocomplete
                                                :value="doctor.id"
                                                @change="(value) => { return setOtherDoctorId({index: index, data: value}) }"
                                                :items="doctorsList"
                                                item-text="name"
                                                item-value="id"
                                                label="Nom du médecin"
                                                append-outer-icon="clear"
                                                @click:append-outer="removeDoctor(index)"
                                            ></v-autocomplete>
                                        </v-flex>

                                    </v-layout>
                                    <v-layout>
                                        <v-btn flat color="secondary" @click="addDoctor">Ajouter un médecin</v-btn>
                                    </v-layout>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn color="success" @click="validateDoctors" class="right">Suivant</v-btn>

                                <v-btn v-if="mode == 'create' && locked == 'null'" color="secondary" @click="skip"
                                       class="right">
                                    Passer
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-form ref="firmForm" v-model="firmInfoValid" lazy-validation>
                        <v-layout>
                            <v-flex md6 offset-md3>
                                <h3 class="headline mb-4">Comment avez-vous choisi ce cabinet :</h3>
                                <v-select
                                    :menu-props="{ maxHeight: '100%' }"
                                    v-model="selectFirm"
                                    :items="[
                                    {text: getText('doctor'), value: 'doctor'},
                                    {text: getText('physio'), value: 'physio'},
                                    {text: getText('internet'), value: 'internet'},
                                    {text: getText('reception'), value: 'reception'},
                                    {text: getText('emergencies'), value: 'emergencies'},
                                    {text: getText('person_advise'), value: 'person_advise'},
                                    {text: getText('other'), value: 'other'},
                                    {text: getText('dont_know'), value: 'dont_know'}
                                    ]"
                                    label="Via"
                                ></v-select>
                                <v-text-field
                                    v-if="selectFirm === 'doctor' || selectFirm === 'physio' || selectFirm === 'other'"
                                    v-model="selectFirmOther" label="Nom: "></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn :disabled="!firmInfoValid" color="success" @click="validateFirm" class="right">
                                    Suivant
                                </v-btn>

                                <v-btn v-if="mode == 'create' && locked == 'null'" color="secondary" @click="skip"
                                       class="right">
                                    Passer
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="5">
                    <v-form ref="jobForm" v-model="jobInfoValid" lazy-validation>
                        <v-layout>
                            <v-flex md6 offset-md3>
                                <h3 class="headline mb-4">Quel est votre type de travail :</h3>
                                <v-select
                                    v-model="job"
                                    :items="[
                                    {text: getText('desk'), value: 'desk'},
                                    {text: getText('admin_manual'), value: 'admin_manual'},
                                    {text: getText('manual_light'), value: 'manual_light'},
                                    {text: getText('manual_heavy'), value: 'manual_heavy'},
                                    {text: getText('unemployed'), value: 'unemployed'},
                                    {text: getText('retired'), value: 'retired'},
                                    {text: getText('housewife'), value: 'housewife'},
                                    {text: getText('sport_pro'), value: 'sport_pro'},
                                    ]"
                                    label="Travail"
                                ></v-select>

                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn :disabled="!jobInfoValid" color="success" @click="validateJob" class="right">
                                    Enregistrer
                                </v-btn>

                                <v-btn v-if="mode == 'create' && locked == 'null'" color="secondary" @click="skip"
                                       class="right">
                                    Passer
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <v-layout justify-center>
            <v-dialog v-model="dialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Nouveau Patient</v-card-title>
                    <v-card-text>Voulez-vous vérouiller la tablette et activer la saisie patient ?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="continueAsSecretary">Non, continuer</v-btn>
                        <v-btn color="primary" text @click="continueAsPatient">Oui, verrouiller</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout justify-center>
            <v-dialog v-model="quickCreateDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Création rapide</v-card-title>
                    <v-card-text>
                        <v-form ref="quickCreateForm" v-model="quickCreateInfoValid" lazy-validation>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field :rules="emailRules"
                                                      :value="email ? email.toLowerCase() : ''"
                                                      @input="(value) => { setEmail(value ? value.toLowerCase() : null) }"
                                                      label="Email"></v-text-field>

                                        <v-text-field v-model="phone" label="Téléphone"></v-text-field>
                                        <v-text-field v-model="address" label="Adresse"></v-text-field>
                                        <v-text-field v-model="postcode" label="Code postal"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            :value="type"
                                            :rules="[v => !!v || 'Item is required']"
                                            :items="[
                                                {text: getText('DIAGNOSTIC_GONARTHROSE'), value: 'DIAGNOSTIC_GONARTHROSE'},
                                                //{text: getText('DIAGNOSTIC_ARTHROSE_HANCHE'), value: 'DIAGNOSTIC_ARTHROSE_HANCHE'},
                                                {text: getText('DIAGNOSTIC_LCA'), value: 'DIAGNOSTIC_LCA'},
                                                {text: getText('DIAGNOSTIC_LCP'), value: 'DIAGNOSTIC_LCP'},
                                                {text: getText('DIAGNOSTIC_LPI'), value: 'DIAGNOSTIC_LPI'},
                                                {text: getText('DIAGNOSTIC_LPE'), value: 'DIAGNOSTIC_LPE'},
                                                {text: getText('DIAGNOSTIC_LM'), value: 'DIAGNOSTIC_LM'},
                                                {text: getText('DIAGNOSTIC_CARTI_NON_DEG'), value: 'DIAGNOSTIC_CARTI_NON_DEG'},
                                                {text: getText('DIAGNOSTIC_ROTULE'), value: 'DIAGNOSTIC_ROTULE'},
                                                {text: getText('DIAGNOSTIC_LESION_CARTI_ROTULE'), value: 'DIAGNOSTIC_LESION_CARTI_ROTULE'},
                                                {text: getText('DIAGNOSTIC_OTHER'), value: 'DIAGNOSTIC_OTHER'},
                                            ]"
                                            @change="(value) => { setDiagnosticType(value) }"
                                            label="Type"
                                            required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-menu v-model="showTreatmentDatePicker"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateFormatted"
                                                    label="Date de l'intervention"
                                                    append-icon="event"
                                                    v-on="on"
                                                    :rules="[v => !!v || 'Le champs est requis']"
                                                    @blur="intervention_date = parseDate(dateFormatted)"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="intervention_date" no-title locale="fr"
                                                           @input="showTreatmentDatePicker = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            :value="treatmentType"
                                            :rules="[v => !!v || 'Le champs est requis']"
                                            :items="[
                                                {text: getText('TREATMENT_FULL_KNEE_REPLACEMENT'), value: 'TREATMENT_FULL_KNEE_REPLACEMENT'},
                                                //{text: getText('TREATMENT_FULL_HIP_REPLACEMENT'), value: 'TREATMENT_FULL_HIP_REPLACEMENT'},
                                                {text: getText('TREATMENT_INF_CORTISONE'), value: 'TREATMENT_INF_CORTISONE'},
                                                {text: getText('TREATMENT_INF_ACIDE_HYALURONIQUE'), value: 'TREATMENT_INF_ACIDE_HYALURONIQUE'},
                                                {text: getText('TREATMENT_SURGERY'), value: 'TREATMENT_SURGERY'},
                                                {text: getText('TREATMENT_PHYSIO'), value: 'TREATMENT_PHYSIO'},
                                                {text: getText('TREATMENT_OSTEO'), value: 'TREATMENT_OSTEO'},
                                                {text: getText('TREATMENT_OTHER'), value: 'TREATMENT_OTHER'},
                                            ]"
                                            @change="(value) => { setTreatmentType(value) }"
                                            label="Traitement"
                                            required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex v-if="treatmentType === 'TREATMENT_FULL_KNEE_REPLACEMENT'
                                    || treatmentType === 'TREATMENT_PARTIAL_KNEE_REPLACEMENT'
                                    || treatmentType === 'TREATMENT_REVISION_KNEE_ARTHROPLASTY'" xs12>
                                        <v-select
                                            :value="treatmentSubType"
                                            :rules="[v => !!v || 'Le champs est requis']"
                                            :items="treatmentType === 'TREATMENT_FULL_KNEE_REPLACEMENT' ?
                                            [
                                                    {text: this.getText('PTG_STANDARD'), value: 'PTG_STANDARD'},
                                                    {text: this.getText('PTG_MAKO'), value: 'PTG_MAKO'},
                                                    {text: this.getText('PTG_MYKNEE'), value: 'PTG_MYKNEE'},
                                                    {text: this.getText('PTG_NEXT_AR'), value: 'PTG_NEXT_AR'},
                                                    {text: this.getText('PTG_SYMBIOS'), value: 'PTG_SYMBIOS'},
                                                    {text: this.getText('PTG_UPDATE'), value: 'PTG_UPDATE'},
                                                ] : (
                                                    treatmentType === 'TREATMENT_PARTIAL_KNEE_REPLACEMENT' ?
                                                    [
                                                        {text: this.getText('PUC'), value: 'PUC'},
                                                        {text: this.getText('PUC_MAKO'), value: 'PUC_MAKO'},
                                                        {text: this.getText('PUC_MYKNEE'), value: 'PUC_MYKNEE'},
                                                        {text: this.getText('PUC_UPDATE'), value: 'PUC_UPDATE'},
                                                    ] : [
                                                        {text: this.getText('PTG_STANDARD'), value: 'PTG_STANDARD'},
                                                        {text: this.getText('PTG_MAKO'), value: 'PTG_MAKO'},
                                                        {text: this.getText('PTG_MYKNEE'), value: 'PTG_MYKNEE'},
                                                        {text: this.getText('PTG_NEXT_AR'), value: 'PTG_NEXT_AR'},
                                                        {text: this.getText('PTG_SYMBIOS'), value: 'PTG_SYMBIOS'},
                                                        {text: this.getText('PTG_UPDATE'), value: 'PTG_UPDATE'},
                                                        {text: this.getText('PUC'), value: 'PUC'},
                                                        {text: this.getText('PUC_MAKO'), value: 'PUC_MAKO'},
                                                        {text: this.getText('PUC_MYKNEE'), value: 'PUC_MYKNEE'},
                                                        {text: this.getText('PUC_UPDATE'), value: 'PUC_UPDATE'},
                                                    ]
                                                )"
                                            @change="(value) => { setTreatmentSubType(value) }"
                                            label="Sous-type"
                                            required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            :menu-props="{ maxHeight: '100%' }"
                                            v-model="selectFirm"
                                            :items="[
                                                {text: getText('doctor'), value: 'doctor'},
                                                {text: getText('physio'), value: 'physio'},
                                                {text: getText('internet'), value: 'internet'},
                                                {text: getText('reception'), value: 'reception'},
                                                {text: getText('emergencies'), value: 'emergencies'},
                                                {text: getText('person_advise'), value: 'person_advise'},
                                                {text: getText('other'), value: 'other'},
                                                {text: getText('dont_know'), value: 'dont_know'}
                                                ]"
                                            label="Comment avez-vous choisi ce cabinet :"
                                        ></v-select>
                                        <v-text-field
                                            v-if="selectFirm === 'doctor' || selectFirm === 'physio' || selectFirm === 'other'"
                                            v-model="selectFirmOther" label="Nom: "></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="cancelQuickCreate">Annuler</v-btn>
                        <v-btn color="primary" text @click="validateQuickCreate">Créer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import {getTranslationString} from "../../helper"
import countries from "../../countries"

export default {
    name: "PatientForm",
    props: {
        mode: {
            type: String,
            default: 'create'
        }
    },
    data() {
        return {
            showDatePicker: false,
            showTreatmentDatePicker: false,
            dialog: false,
            quickCreateDialog: false,
            quickCreateInfoValid: false,
            patientInfoValid: false,
            contactInfoValid: false,
            doctorsInfoValid: false,
            firmInfoValid: false,
            jobInfoValid: false,
            //tegnerInfoValid: false,
            step: 1,
            dateFormatted: '',
            nameRules: [
                v => !!v || 'Le nom est requis'
            ],
            emailRules: [
                v => (!v || (/.+@.+\..+/.test(v))) || 'E-mail must be valid'
            ],
            dateRules: [
                v => !!v || 'La date de naissance est requise'
            ],
            genderRules: [
                v => !!v || 'Le genre est requis',
            ],
            opaleNumberRules: [
                v => !!v || 'Le numéro OPALE est requis'
            ],

            birthDateFormatted: ''
        }
    },
    computed: {
        countryList() {
            return countries
        },
        ...mapState({
            locked: state => state.locked
        }),
        ...mapState('patients', {
            selectedPatientId: state => state.selectedPatient.id
            //tegnerScore: state => state.tegnerScore
        }),
        ...mapState('doctors', {
            doctorsList: state => [{id: null, name: ''}, ...state.all]
        }),
        ...mapState('physios', {
            physiosList: state => [{id: null, name: ''}, ...state.all]
        }),
        intervention_date: {
            get() {
                return this.$store.state.patients.form.intervention_date
            },
            set(value) {
                this.setInterventionDate(value)
            }
        },
        treatmentType: {
            get() {
                return this.$store.state.patients.form.treatment_type
            },
            set(value) {
                this.setTreatmentType(value)
            }
        },
        treatmentSubType: {
            get() {
                return this.$store.state.patients.form.treatment_subtype
            },
            set(value) {
                this.setTreatmentSubType(value)
            }
        },
        type: {
            get() {
                return this.$store.state.patients.form.diagnostic_type
            },
            set(value) {
                this.setDiagnosticType(value)
            }
        },
        gender: {
            get() {
                return this.$store.state.patients.form.gender
            },
            set(value) {
                this.setGender(value)
            }
        },
        opaleNumber: {
            get() {
                return this.$store.state.patients.form.opale_number
            },
            set(value) {
                this.setOpaleNumber(value)
            }
        },
        declinedStudy: {
            get() {
                return this.$store.state.patients.form.declined_study
            },
            set(value) {
                this.setDeclinedStudy(value)
            }
        },
        declineDataCollection: {
            get() {
                return this.$store.state.patients.form.decline_data_collection
            },
            set(value) {
                this.setDeclineDataCollection(value)
            }
        },
        firstname: {
            get() {
                return this.$store.state.patients.form.firstname
            },
            set(value) {
                this.setFirstname(value)
            }
        },
        lastname: {
            get() {
                return this.$store.state.patients.form.lastname
            },
            set(value) {
                this.setLastname(value)
            }
        },
        birth_date: {
            get() {
                return this.$store.state.patients.form.birth_date
            },
            set(value) {
                this.setBirthDate(value)
            }
        },
        email: {
            get() {
                return this.$store.state.patients.contactForm.email
            },
            set(value) {
                this.setEmail(value)
            }
        },
        noEmail: {
            get() {
                return this.$store.state.patients.contactForm.no_email
            },
            set(value) {
                this.setNoEmail(value)
            }
        },
        phone: {
            get() {
                return this.$store.state.patients.contactForm.phone
            },
            set(value) {
                this.setPhone(value)
            }
        },
        address: {
            get() {
                return this.$store.state.patients.contactForm.address
            },
            set(value) {
                this.setAddress(value)
            }
        },
        postcode: {
            get() {
                return this.$store.state.patients.contactForm.postcode
            },
            set(value) {
                this.setPostcode(value)
            }
        },
        city: {
            get() {
                return this.$store.state.patients.contactForm.city
            },
            set(value) {
                this.setCity(value)
            }
        },
        country: {
            get() {
                return this.$store.state.patients.contactForm.country
            },
            set(value) {
                this.setCountry(value)
            }
        },
        notification: {
            get() {
                return this.$store.state.patients.contactForm.notification
            },
            set(value) {
                this.setNotification(value)
            }
        },
        mainDoctorId: {
            get() {
                return this.$store.state.patients.doctorsForm.main.id
            },
            set(value) {
                this.setMainDoctorId(value)
            }
        },
        noDoctor: {
            get() {
                return this.$store.state.patients.doctorsForm.no_doctor
            },
            set(value) {
                this.setNoDoctor(value)
            }
        },
        physioId: {
            get() {
                return this.$store.state.patients.doctorsForm.physio.id
            },
            set(value) {
                this.setPhysioId(value)
            }
        },
        noPhysio: {
            get() {
                return this.$store.state.patients.doctorsForm.no_physio
            },
            set(value) {
                this.setNoPhysio(value)
            }
        },
        otherDoctors: {
            get() {
                return this.$store.state.patients.doctorsForm.others
            },
            set(value) {
                this.setOtherDoctors(value)
            }
        },
        selectFirm: {
            get() {
                return this.$store.state.patients.firmForm.firm_select
            },
            set(value) {
                this.setSelectFirm(value)
            }
        },
        selectFirmOther: {
            get() {
                return this.$store.state.patients.firmForm.firm_select_other
            },
            set(value) {
                this.setSelectFirmOther(value)
            }
        },
        job: {
            get() {
                return this.$store.state.patients.jobForm.job
            },
            set(value) {
                this.setJob(value)
            }
        },
        /*tegner: {
            get() {
                return this.$store.state.patients.tegnerForm.tegner
            },
            set(value) {
                this.setTegner(value)
            }
        },*/
    },
    mounted() {
        //this.getTegner()
        this.getAllDoctors()
        this.getAllPhysios()

        if (this.mode === 'create') {
            this.birth_date = null
            this.$refs.patientForm.reset()
            //this.$refs.contactForm.reset()
            this.$refs.doctorsForm.reset()
            this.$refs.firmForm.reset()
            this.$refs.jobForm.reset()
            //this.$refs.tegnerForm.reset()
            this.$refs.quickCreateForm.reset()

            this.gender = ''
            this.opale_number = ''
            this.firstname = ''
            this.lastname = ''
            this.birth_date = null
            this.email = ''
            this.phone = ''
            this.address = ''
            this.postcode = ''
            this.city = ''
            this.country = 'Suisse'
            this.mainDoctorName = ''
            this.physioName = ''
            this.otherDoctors = [{
                name: '',
                pivot: {
                    type: 'OTHER',
                    label: null
                }
            }]

            this.selectFirm = ''
            this.selectFirmOther = ''
            this.job = ''
            //this.tegner = null
            this.notification = true
        } else {
            this.loadPatientForm()
            this.birth_date = this.parseDate(this.birthDateFormatted)
        }
    },
    methods: {
        showLabel(index) {
            if (this.$refs['typeSelect_' + index]) {
                return this.$refs['typeSelect_' + index].value === "OTHER"
            }
            return false
        },
        previous() {
            this.step = this.step - 1
        },
        validate() {
            if (this.$refs.patientForm.validate()) {
                this.submit()
            }
        },
        validateContact() {
            if (this.$refs.contactForm.validate()) {
                this.submitContactInfos()
            }
        },
        validateDoctors() {
            if (this.$refs.doctorsForm.validate()) {
                this.submitDoctorsInfos()
            }
        },
        validateFirm() {
            if (this.$refs.firmForm.validate()) {
                this.submitFirmInfos()
            }
        },
        validateJob() {
            if (this.$refs.jobForm.validate()) {
                this.submitJobInfos()
            }
        },
        /*validateTegner() {
            if (this.$refs.tegnerForm.validate()) {
                this.submitTegnerInfos()
            }
        },*/
        submitContactInfos() {
            this.updateContactInfos().then(response => {
                this.step = 3
            }).catch(reason => {
                //Stay here..
            })
        },
        submitDoctorsInfos() {
            this.updateDoctorsInfos().then(response => {
                this.step = 4
            }).catch(reason => {
                //Stay here..
            })

        },
        submitFirmInfos() {
            this.updateFirmInfos().then(response => {
                this.step = 5
            }).catch(reason => {
                //Stay here..
            })
        },
        submitJobInfos() {
            this.updateJobInfos().then(response => {
                this.$router.replace({name: 'patient.view', params: {id: this.selectedPatientId}})
            }).catch(reason => {
                //Stay here..
            })
        },
        /*submitTegnerInfos() {
            this.updateTegnerInfos().then(response => {
                this.$router.replace({name: 'patient.view', params: {id: this.selectedPatientId}})
            }).catch(reason => {
                //Stay here..
            })
        },*/
        continueAsSecretary() {
            this.dialog = false
            this.step = 2
        },
        continueAsPatient() {
            this.dialog = false

            this.updateLockedState("true")

            this.step = 2
        },
        submit() {
            if (this.mode == 'create') {
                this.createPatient().then(response => {
                    if (response.data.state === 'new') {
                        this.setSelectedPatientId(response.data.patient)
                        this.dialog = true
                    } else {
                        //Move back to the user list
                        this.$router.replace({name: 'patient.view', params: {id: response.data.patient}})
                    }

                }).catch(reason => {
                    //Stay here..
                })
            } else {
                this.updatePatient().then(response => {
                    this.step = 2
                }).catch(reason => {
                    //Stay here..
                })
            }

        },
        skip() {
            this.$router.replace({name: 'patient.view', params: {id: this.selectedPatientId}})
        },
        showQuickCreateModal() {
            if (this.$refs.patientForm.validate()) {
                this.quickCreateDialog = true
            }
        },
        cancelQuickCreate() {
            this.quickCreateDialog = false
        },
        validateQuickCreate() {
            if (this.$refs.quickCreateForm.validate()) {
                this.submitQuickCreate()
            }
        },
        submitQuickCreate() {
            this.quickCreatePatient().then(response => {
                this.$router.replace({name: 'patient.view', params: {id: response.data.patient}})
            }).catch(reason => {
                //Stay here..
            })
        },
        getText(key) {
            return getTranslationString(key)
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        hasSubTypes(type) {
            return this.subTypes[type] && this.subTypes[type].length > 0
        },
        ...mapMutations(['updateLockedState', 'setLockedBack']),
        ...mapMutations('patients', {
            setGender: 'setFormGender',
            setOpaleNumber: 'setFormOpaleNumber',
            setDeclinedStudy: 'setFormDeclinedStudy',
            setDeclineDataCollection: 'setFormDeclineDataCollection',
            setFirstname: 'setFormFirstname',
            setLastname: 'setFormLastname',
            setBirthDate: 'setFormBirthDate',
            setEmail: 'setFormEmail',
            setNoEmail: 'setFormNoEmail',
            setPhone: 'setFormPhone',
            setAddress: 'setFormAddress',
            setPostcode: 'setFormPostcode',
            setCity: 'setFormCity',
            setCountry: 'setFormCountry',
            setNotification: 'setFormNotification',
            setMainDoctorId: 'setFormMainDoctorId',
            setNoDoctor: 'setFormNoDoctor',
            setPhysioId: 'setFormPhysioId',
            setNoPhysio: 'setFormNoPhysio',
            setSelectedPatientId: 'setSelectedPatientId',
            initPatientForms: 'initPatientForms',
            setOtherDoctorType: 'setFormOtherDoctorType',
            setOtherDoctorId: 'setFormOtherDoctorId',
            setOtherDoctorLabel: 'setFormOtherDoctorLabel',
            addDoctor: 'addNewEmptyDoctor',
            setSelectFirm: 'setFormSelectFirm',
            setSelectFirmOther: 'setFormSelectFirmOther',
            setOtherDoctors: 'setOtherDoctors',
            setJob: 'setFormJob',
            //setTegner: 'setFormTegner',
            removeDoctor: 'removeDoctorAtIndex',
            setTreatmentType: 'setFormTreatmentType',
            setTreatmentSubType: 'setFormTreatmentSubType',
            setDiagnosticType: 'setFormDiagnosticType',
            setInterventionDate: 'setFormInterventionDate',
        }),
        ...mapActions('patients', ['createPatient', 'quickCreatePatient', 'updatePatient', 'updateContactInfos', 'updateDoctorsInfos', 'updateFirmInfos', 'updateJobInfos', 'loadPatientForm']),
        ...mapActions('doctors', ['getAllDoctors']),
        ...mapActions('physios', ['getAllPhysios'])
    },
    watch: {
        showDatePicker(val) {
            this.birth_date ? val : (val && setTimeout(() => (this.$refs.birthdayPicker.activePicker = 'YEAR')))
        },
        birth_date(date) {
            this.birthDateFormatted = date ? this.$options.filters.formatedDate(date) : ''
        },
        intervention_date(date) {
            this.dateFormatted = date ? this.$options.filters.formatedDate(date) : ''
        }

    },
}
</script>

<style scoped>

</style>
